<template>
  <div class="site_subscribe">
    <van-sticky>
      <van-nav-bar title="取消订单" left-arrow @click-left="goback()" />
    </van-sticky>

    <!-- 表单 -->
    <van-form
      :show-error="false"
      @submit="onSubmit"
      error-message-align="right"
    >
      <van-cell-group :border="false">
        <div class="subscribe_title">填写取消理由</div>

        <van-field
          v-model="submitData.reason"
          rows="2"
          autosize
          type="textarea"
          maxlength="200"
          placeholder="请检单填写你的取消理由"
          show-word-limit
          :rules="[{ required: true, message: '请输入取消理由' }]"
        />
      </van-cell-group>

      <van-button
        class="m-t25"
        block
        color="#0CADFC"
        type="info"
        native-type="submit"
        >确认取消</van-button
      >
    </van-form>
  </div>
</template>

<script>
import { Button, NavBar, Sticky, Form, Field } from "vant";
export default {
  components: {
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [Sticky.name]: Sticky,
    [Form.name]: Form,
    [Field.name]: Field,
  },
  data() {
    return {
      submitData: {
        reason: "",
        id: 0,
      },
    };
  },

  //初始化加载
  created() {
    this.submitData.id = this.$route.params.id;
  },

  methods: {
    //返回上一页
    goback() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        this.$router.push({ path: "/order/index" });
        //this.$router.go(-1);
      }
    },

    onSubmit() {
      var that = this;
      that.$api
        .orderInfoUserH5CancelAPI(that.submitData)
        .then(function (res) {
          if (res.data.code === 200) {
            that.$Notify({
              type: "success",
              message: "操作成功",
              onClose() {
                that.$router.go(-1);
              },
            });
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },
  },
};
</script>

<style lang="less" scoped>
.site_subscribe {
  .subscribe_title {
    font-size: 14px;
    color: #666;
    padding: 15px 20px;
    background: #f4f3f8;
  }

  /deep/ .van-field__value {
    background: #f4f3f8;
    padding: 5px;
  }

  // 表单
  .van-button {
    width: 350px;
    margin: auto;
    margin-top: 20px;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/order/cancelOrder.vue